import { jsx as _jsx } from "react/jsx-runtime";
export function Rectangle(props) {
    return _jsx("rect", { ...props });
}
//# sourceMappingURL=Rectangle.js.map